import React, { Component, Fragment } from "react";

import { withStyles } from "@material-ui/core/styles";

import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";

import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";

// Icons import
import SearchIcon from "@material-ui/icons/Search";
import CancelIcon from "@material-ui/icons/Cancel";

import { ReactComponent as GuideIcon } from "./svg/guide.svg";
import { ReactComponent as QuestionnaireIcon } from "./svg/questionnaire.svg";
import { ReactComponent as StudyaidIcon } from "./svg/study-aid.svg";

const useStyles = (theme) => ({
  root: {
    width: "100%",
  },
  container: {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gridGap: theme.spacing(3),
  },
  searchbar: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    marginTop: 10,
    marginBottom: 10,
  },
  heading: {
    fontSize: theme.typography.pxToRem(14),
    flexBasis: "3%",
    flexShrink: 0,
    fontWeight: "bold",
    marginLeft: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(14),
    flexBasis: "90%",
    color: "#555555",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  divider: {
    marginBottom: 15,
  },
});

class MainContent extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.searchBarHandleChange = this.searchBarHandleChange.bind(this);
    this.removeSearchtext = this.removeSearchtext.bind(this);
    this.state = {
      isLoading: true,
      osapdata: [],
      osapSearch: "",
      osapSearchResult: [],
      error: null,
      expanded: false,
    };
    this.timeout = 0;
  }

  componentDidMount() {
    this.importData();

    this.setHashValue();
    window.addEventListener("hashchange", (e) => {
      this.setHashValue();
    });
  }

  importData() {
    const _self = this;
    const body = document.querySelector("body");
    const callbackName = "processJSONPResponse";
    let script = document.createElement("script");
    script.src = window.OSAP_SEARCH_BASEURL + window.OSAP_SEARCH_DATA;
    script.charset = "utf-8";
    body.appendChild(script);

    window[callbackName] = function (data) {
      _self.setState({
        osapdata: data,
        isLoading: false,
        osapSearchResult: data,
      });
      cleanUp();
    };

    function cleanUp() {
      window[callbackName] = undefined;
      body.removeChild(script);
      script = null;
    }
  }

  handleChange = (panel) => (event, isExpanded) => {
    if (isExpanded) {
      this.setState({ expanded: panel });
    } else {
      this.setState({ expanded: false });
    }
  };

  setHashValue() {
    const searchParam = window.location.hash.replace(/^#o/, "");

    if (searchParam) {
      const r = { target: { value: searchParam } };
      this.searchBarHandleChange(r);
    }
  }

  searchBarHandleChange = (e) => {
    this.setState({ osapSearch: e.target.value });
    this.doSearch();
  };

  doSearch() {
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.searching();
    }, 300);
  }

  searching() {
    const { osapdata, osapSearch } = this.state;

    let optionsChekcer;

    if (osapSearch.length > 0) {
      optionsChekcer = osapdata.filter((option) => {
        const searchId = osapSearch.match(/\d+/g)
          ? osapSearch.match(/\d+/g)[0].toString().trim()
          : "";
        const searchMegnevezes = osapSearch
          .toLowerCase()
          .replace(/\d+/g, "")
          .trim();

        const oId = option && option.id ? "" + option.id : "";
        const oMegnevezes =
          option && option.megnevezes
            ? "" + option.megnevezes.toLowerCase().trim()
            : "";

        if (
          oId.indexOf(searchId) !== -1 &&
          oMegnevezes.indexOf(searchMegnevezes) !== -1
        ) {
          return true;
        } else {
          return false;
        }
      });

      this.setState({ osapSearchResult: optionsChekcer });
    } else {
      this.setState({ osapSearchResult: osapdata });
    }
  }

  removeSearchtext = () => {
    window.scrollTo(0, 0);
    this.setState({ osapSearch: "", osapSearchResult: this.state.osapdata });
  };

  render() {
    const { classes } = this.props;
    const { isLoading, osapSearch, error } = this.state;

    return (
      <React.Fragment>
        {error ? <p>{error.message}</p> : null}
        {!isLoading ? (
          <>
            <CssBaseline />
            <Container maxWidth={false}>
              <Paper className={"searchBarSticky " + classes.searchbar}>
                <InputBase
                  className={classes.input}
                  placeholder="OSAP-szám és/vagy megnevezése..."
                  onChange={this.searchBarHandleChange}
                  value={osapSearch}
                  autoFocus={true}
                />
                {osapSearch.length > 0 ? (
                  <CancelIcon
                    className="searchRemoveIcon"
                    onClick={() => this.removeSearchtext()}
                  />
                ) : null}
                <IconButton
                  type="submit"
                  className={classes.iconButton}
                  aria-label="search"
                >
                  <SearchIcon />
                </IconButton>
              </Paper>
              <div className={classes.root}>{this.OSAPList()}</div>
            </Container>
          </>
        ) : (
          <>
            <CssBaseline />
            <Container maxWidth={false}>
              <Paper className="loadingScreen">Kereső betöltése...</Paper>
            </Container>
          </>
        )}
      </React.Fragment>
    );
  }

  OSAPList() {
    const { classes } = this.props;
    const { expanded, osapSearchResult } = this.state;

    if (osapSearchResult.length === 0) {
      return <Paper className="notResultFound">Nincs ilyen találat!</Paper>;
    } else {
      return osapSearchResult.map((osap, osapIndex) => {
        const {
          id,
          megnevezes,
          beerkezesi_hatarido,
          ksh_elektra,
          kerdoiv,
          segedlet,
          utmutato,
          megjegyzes,
          elrendelo_szerv,
          bekuldesi_email_cim,
          bekuldesi_postacim,
          gyakorisag,
          url,
          felelos_munkatarsak,
        } = osap;

        let megjegyzesContent;

        if (megjegyzes.indexOf("KSH-ELEKTRA") !== -1) {
          megjegyzesContent = megjegyzes.replace(
            "KSH-ELEKTRA",
            '<a rel="noreferrer" target="_blank" href="' +
              url +
              '">KSH-ELEKTRA</a>'
          );
        } else {
          megjegyzesContent = megjegyzes;
        }

        // Multiply files availabel
        let open;

        if (osapSearchResult.length === 1) {
          open = true;
        } else {
          open = expanded === id;
        }

        const [kerdoivContent, segedletContent, utmutatoContent] = [
          kerdoiv,
          segedlet,
          utmutato,
        ].map((item, index) => {
          let content, label, icon;

          const iconClasses = "osapFileIcons" + (!item ? " notAllowIcon" : "");

          switch (index) {
            case 0:
              label = "Kérdőív";
              icon = <QuestionnaireIcon className={iconClasses} />;
              break;
            case 1:
              label = "Segédlet";
              icon = <GuideIcon className={iconClasses} />;
              break;
            case 2:
              label = "Útmutató";
              icon = <StudyaidIcon className={iconClasses} />;
              break;
            default:
              label = "Letöltés";
              break;
          }

          if (item) {
            const newItem = item.replace(/\n/g, "|");

            if (newItem && newItem.indexOf("|") !== -1) {
              const itemsArray = newItem.split("|");

              const mutliLink = () => {
                return (
                  <div>
                    {itemsArray.map((uri, i) => { 
                      const fullURL = /(http(s?)):\/\//i.test(uri) ? uri : window.OSAP_SEARCH_BASEURL + uri;
                      return (
                        <div key={i}>
                          <a
                            rel="noreferrer"
                            target="_blank"
                            href={fullURL}
                            className="osapFileIconsTitle"
                          >
                            {label}
                          </a>
                        </div>
                      ) 
                    })
                    }
                  </div>
                );
              };

              content = (
                <div key={index}>
                  {icon} {mutliLink()}
                </div>
              );
            } else {
              const fullURL = /(http(s?)):\/\//i.test(newItem) ? newItem : window.OSAP_SEARCH_BASEURL + newItem;
              content = (
                <div key={index}>
                  {icon}{" "}
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href={fullURL}
                    className="osapFileIconsTitle"
                  >
                    {label}
                  </a>
                </div>
              );
            }
          } else {
            content = (
              <div key={index}>
                {icon}
                <p className="osapFileIconsTitle notAllow">
                  {label}
                  <br />
                  nem érhető el
                </p>
              </div>
            );
          }

          return content;
        });

        return (
          <Accordion
            key={osapIndex}
            expanded={open}
            onChange={this.handleChange(id)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <div className={classes.heading}>{id}</div>
              <div className={"osapLabel " + classes.secondaryHeading}>
                {megnevezes}
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container={true} spacing={3}>
                <Grid item={true} xs={12} sm={12} md={4}>
                  <Grid container={true} spacing={3}>
                    <Grid
                      className="iconColumn"
                      item={true}
                      xs={12}
                      sm={4}
                      md={4}
                      lg={4}
                    >
                      {kerdoivContent}
                    </Grid>
                    <Grid
                      className="iconColumn"
                      item={true}
                      xs={12}
                      sm={4}
                      md={4}
                      lg={4}
                    >
                      {utmutatoContent}
                    </Grid>
                    <Grid
                      className="iconColumn"
                      item={true}
                      xs={12}
                      sm={4}
                      md={4}
                      lg={4}
                    >
                      {segedletContent}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item={true} xs={12} sm={12} md={8}>
                  <div key={id} className="osapContentBox">
                    <p>
                      <b>Beérkezési határidő:</b> {beerkezesi_hatarido}
                    </p>
                    {ksh_elektra ? (
                      <p>
                        <a rel="noreferrer" target="_blank" href={url}>
                          KSH ELEKTRA-ban küldendő
                        </a>
                      </p>
                    ) : (
                      ""
                    )}
                    <b>Megjegyzés:</b>{" "}
                    <div
                      className="reviewContent"
                      dangerouslySetInnerHTML={{ __html: megjegyzesContent }}
                    />
                    <p>
                      <b>Elrendelő szerv:</b> {elrendelo_szerv}
                    </p>
                    {bekuldesi_email_cim.indexOf("@") !== -1 ? (
                      <p>
                        <b>Beküldési e-mail cím:</b>{" "}
                        <a href={"mailto" + bekuldesi_email_cim.toLowerCase()}>
                          {bekuldesi_email_cim.toLowerCase()}
                        </a>
                      </p>
                    ) : (
                      ""
                    )}
                    {bekuldesi_postacim ? (
                      <p>
                        <b>Beküldési postacím:</b> {bekuldesi_postacim}
                      </p>
                    ) : (
                      ""
                    )}
                    <p>
                      <b>Gyakoriság:</b> {gyakorisag}
                      {(window.OSAP_SPECIAL_LINK !== "" && id === window.OSAP_SPECIAL_LINK_ID) ? (
                        <React.Fragment>
                          <br />
                          <br />
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href={window.OSAP_SPECIAL_LINK}
                          >
                            Részletes kérdőívek
                          </a>
                        </React.Fragment>
                      ) : (
                        ""
                      )}
                    </p>
                    <br />
                    <p>
                      <b>
                        {felelos_munkatarsak[0]["felelos_munkatars_neve"]
                          ? "A kitöltéssel kapcsolatban kérdéseit felteheti közvetlenül az adatgyűjtésért felelős munkatársunknak az alábbi elérhetőségeken:"
                          : "Nincs elérhető kapcsolattartó."}
                      </b>
                    </p>
                    <div>
                      {felelos_munkatarsak.map((felelos_munkatars, index) => {
                        const {
                          felelos_munkatars_neve,
                          felelos_munkatars_telefonszama,
                          felelos_munkatars_email_cime,
                        } = felelos_munkatars;

                        let validateMultiPhoneNumbers = [];
                        if (felelos_munkatars_telefonszama.indexOf(";") > -1) {
                          validateMultiPhoneNumbers =
                            felelos_munkatars_telefonszama.split(";");
                        } else {
                          validateMultiPhoneNumbers.push(
                            felelos_munkatars_telefonszama
                          );
                        }

                        let desplayPhoneNumber;
                        if (
                          validateMultiPhoneNumbers !== null &&
                          validateMultiPhoneNumbers !== undefined &&
                          validateMultiPhoneNumbers.length > 1
                        ) {
                          const mutliLink2 = () => {
                            return (
                              <>
                                {validateMultiPhoneNumbers.map(
                                  (phone, index) => {
                                    return (
                                      <Fragment key={index}>
                                        <a href={"tel:" + phone}>
                                          {"+36" + phone}
                                        </a>
                                        <br />
                                      </Fragment>
                                    );
                                  }
                                )}
                              </>
                            );
                          };
                          desplayPhoneNumber = mutliLink2();
                        } else {
                          desplayPhoneNumber = (
                            <a href={"tel:" + felelos_munkatars_telefonszama}>
                              {felelos_munkatars_telefonszama
                                ? "+36 " + felelos_munkatars_telefonszama
                                : ""}
                            </a>
                          );
                        }

                        return (
                          <div
                            className={
                              (index % 2 !== 0
                                ? "osapWorkerContainerOddBg "
                                : "") + "osapWorkerContainer"
                            }
                            key={"felelos-" + felelos_munkatars_neve}
                          >
                            <div className="osapWorkerData">
                              {felelos_munkatars_neve}
                            </div>
                            <div className="osapWorkerData">
                              {desplayPhoneNumber}
                            </div>
                            <div className="osapWorkerData">
                              <a
                                href={"mailto:" + felelos_munkatars_email_cime}
                              >
                                {felelos_munkatars_email_cime}
                              </a>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        );
      });
    }
  }
}
export default withStyles(useStyles)(MainContent);
